import { FC } from 'react'

import { Input, InputProps } from 'antd'
import styled from 'styled-components'

import CloseIcon from 'src/Assets/Svg/pages-icons/Close.svg?react'

const StyledInput = styled(Input)`
  padding: 0;
  border: none;

  &.ant-input-outlined {
    box-shadow: none;
  }
  background: ${({ theme }) => theme.color.white} !important;
  color: ${({ theme }) => theme.color.darkGrey};
  input::placeholder {
    color: ${({ theme }) => theme.color.slateGrey};
  }
`

export type MobileSearchInputProps = InputProps

export const MobileSearchInput: FC<MobileSearchInputProps> = (props) => (
  <StyledInput
    allowClear={{ clearIcon: <CloseIcon /> }}
    {...props}
  ></StyledInput>
)
